import React from 'react';

export const EmptyTableList: React.FC = (): JSX.Element => {
  const attrs = {
    wrapper: { className: 'deals-empty-list' },
    row: { className: 'deals-empty-list__row' },
    checkBox: { className: 'deals-empty-list__row-checkbox' },
  };

  const row = (
    <div {...attrs.row}>
      <div {...attrs.checkBox} />
    </div>
  );

  return (
    <div {...attrs.wrapper}>
      {row}
      {row}
      {row}
      {row}
      {row}
      {row}
      {row}
      {row}
      {row}
      {row}
    </div>
  );
};
